import { Select as AntSelect, Grid } from "antd";
import { BaseOptionType, DefaultOptionType } from "antd/es/select";
import React, { useEffect, useRef, useState } from "react";

import { ResponsiveSelectWrapper } from "./styled";

/**
 * Antd Select component is shown/used on md and higher breakpoints.
 * Transparent native select is overlaid for sm and lower breakpoints to handle selects.
 */
export const ResponsiveSelect: React.FC<
  React.ComponentProps<typeof AntSelect> & {
    mobileOptions: Array<BaseOptionType | DefaultOptionType>;
  }
> = ({ mobileOptions, ...antProps }) => {
  const breakpoints = Grid.useBreakpoint();
  const selectRef = useRef<HTMLSelectElement>(null);
  const antSelectRef = useRef(null);

  const [elRect, setElRect] = useState<DOMRect>();

  useEffect(() => {
    const resizeNativeSelect = () => {
      if (
        antSelectRef.current &&
        (antSelectRef.current as unknown as { nativeElement: HTMLDivElement })
          .nativeElement
      ) {
        setElRect(
          (
            antSelectRef.current as unknown as {
              nativeElement: HTMLDivElement;
            }
          ).nativeElement.getBoundingClientRect()
        );
      }
    };

    resizeNativeSelect();

    addEventListener("resize", resizeNativeSelect);

    return () => {
      removeEventListener("resize", resizeNativeSelect);
    };
  }, []);

  return (
    <ResponsiveSelectWrapper $elRect={elRect} $breakpoints={breakpoints}>
      {!breakpoints.md && (
        <select
          ref={selectRef}
          className="html-select"
          aria-label={antProps["aria-label"] || (antProps.value as string)}
          aria-labelledby={antProps["aria-labelledby"]}
          onChange={
            (el) =>
              antProps.onChange
                ? antProps.onChange(
                    ((el.target as HTMLSelectElement).value as string) || "",
                    {}
                  )
                : undefined //console.info((el.target as HTMLSelectElement).value)
          }
          value={antProps.value as string}
        >
          {mobileOptions.map(({ label, value, options }, idx) => {
            if (options?.length) {
              return (
                <optgroup key={idx} label={label}>
                  {(options as Array<BaseOptionType>).map((opt, optIdx) => {
                    return (
                      <option key={optIdx} value={opt.value}>
                        {opt.label}
                      </option>
                    );
                  })}
                </optgroup>
              );
            }

            return (
              <option key={idx} value={value}>
                {label}
              </option>
            );
          })}
        </select>
      )}
      <AntSelect
        {...antProps}
        aria-hidden={!breakpoints.md}
        aria-label={antProps["aria-label"] || (antProps.value as string)}
        ref={antSelectRef}
        value={antProps.value}
      />
    </ResponsiveSelectWrapper>
  );
};
